import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddVideo(props) {
  return (
    <PostAdd
      targetVid={"video_categories"}
      addPostEndpoint={apiEndpoints.videos}
      editRoute={"/videos/edit"}
      entityType={"video"}
      pageTitle={"Create a video post"}
      returnRoute={"/videos-creator"}
    />
  );
}
